import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=810ed2c6"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('810ed2c6')) {
      api.createRecord('810ed2c6', component.options)
    } else {
      api.reload('810ed2c6', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=810ed2c6", function () {
      api.rerender('810ed2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/paycools/Sidebar/Link.vue"
export default component.exports